import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import { useSelect as useProductCate } from '@/pages/productCate/api';
import React from 'react';
export const SelectProductCate = ({
  value,
  onChange,
  placeholder = '全部'
}) => {
  const {
    data,
    isLoading
  } = useProductCate({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading,
    options: data ? data.data.items.map(v => ({
      label: v.name,
      value: v.id
    })) : [],
    allowClear: true
  });
};